'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _elementIconConstants = require('./elementIconConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function (string) {
    var idPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'str';
    return Immutable.Map({
        type: _elementIconConstants.ICON_TYPES.STRING,
        id: idPrefix + '-' + string,
        string: string.toUpperCase()
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/elementIcon/makeStringIconDef.js
// module id = 430
// module chunks = 0